// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Login {\n  display: block;\n  margin: 0;\n  padding: 0;\n  min-width: calc(100% - 50px);\n  width: calc(100% - 50px);\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
